"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToPolicyDialog = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const core_2 = require("../../../core");
const helpers_1 = require("./helpers");
require("./types");
const AddToPolicyDialogInteractor_1 = require("./AddToPolicyDialogInteractor");
const components_2 = require("./components");
const AddToPolicyDialog = ({ onConfirm, onCancel, onDeactivate, onClose, onCatchError, texts, addToPolicyActionLoadableModel, addToPolicyDataGridModel, instancesIds, }) => {
    const { t } = core_2.useFeatureContext();
    const [isLoading, setIsLoading] = react_1.useState(false);
    const [isAddButtonDisabled, setIsAddButtonDisabled] = react_1.useState(true);
    const [isShowAddToPolicyDialog, setIsShowAddToPolicyDialog] = react_1.useState(true);
    const [addToPolicyResultDialog, addToPolicyResultDialogActions] = components_2.useAddToPolicyResultDialog(texts);
    const policyColumns = helpers_1.getColumns({
        policyNameTitle: (texts === null || texts === void 0 ? void 0 : texts.policyNameColumnTitle) || t('addToPolicyDialog|grid|columns|policy|title'),
        policyDescriptionTitle: (texts === null || texts === void 0 ? void 0 : texts.policyDescriptionColumnTitle) || t('addToPolicyDialog|grid|columns|description|title'),
    });
    const toolbar = helpers_1.getToolbar({
        placeholder: (texts === null || texts === void 0 ? void 0 : texts.searchPlaceholder) || t('addToPolicyDialog|search|placeholder'),
    });
    const { interactor } = core_1.useInteractor(() => {
        const loaders = {
            addToPolicyAction: addToPolicyActionLoadableModel,
            policyList: addToPolicyDataGridModel,
        };
        const presenter = {
            addToPolicyLoadingState: setIsLoading,
            addButtonDisabledState: setIsAddButtonDisabled,
            addToPolicyDialogShowState: setIsShowAddToPolicyDialog,
            showError: onCatchError,
        };
        const listener = {
            onResultDialogActivate: addToPolicyResultDialogActions.show,
            onConfirm,
            onCancel,
            onDeactivate,
            onClose,
        };
        return new AddToPolicyDialogInteractor_1.AddToPolicyDialogInteractor(instancesIds, loaders, listener, presenter);
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isShowAddToPolicyDialog && (react_1.default.createElement(components_1.Dialog, { id: "addToPolicyDialog", header: (texts === null || texts === void 0 ? void 0 : texts.header) || t('addToPolicyDialog|header'), title: (texts === null || texts === void 0 ? void 0 : texts.description) || t('addToPolicyDialog|title'), description: (texts === null || texts === void 0 ? void 0 : texts.description) || t('addToPolicyDialog|description'), loading: isLoading, size: {
                width: components_1.DIALOG_SIZE.m,
                height: components_1.DIALOG_SIZE.xl,
            }, hasTopPadding: false, onRequestClose: () => {
                interactor.onClose();
            }, actions: [
                {
                    view: components_1.ACTION_VIEW.primary,
                    text: t('addToPolicyDialog|actions|add'),
                    onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        yield interactor.onAdd();
                    }),
                    disabled: isAddButtonDisabled,
                },
                {
                    view: components_1.ACTION_VIEW.secondary,
                    text: t('addToPolicyDialog|actions|cancel'),
                    onClick: () => {
                        interactor.onCancel();
                    },
                },
            ] },
            react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, spaceTop: components_1.VIEW_INDENT.s, gap: components_1.STACK_GAP.m },
                react_1.default.createElement(components_1.DataGrid, { model: addToPolicyDataGridModel, toolbar: toolbar, columns: policyColumns, config: {
                        autoLoad: false,
                        canResizeColumns: true,
                        selection: {
                            multi: false,
                        },
                        // disableContextMenu: true,  <-- not in the current version of @veeam/components
                    } })))),
        addToPolicyResultDialog));
};
exports.AddToPolicyDialog = AddToPolicyDialog;
exports.AddToPolicyDialog.displayName = 'AddToPolicyDialog';
//# sourceMappingURL=AddToPolicyDialog.js.map